module.exports = __webpack_public_path__ + "static/media/iblu2.59444c23.jpg";